import React from 'react';
import '../style/Kyagu.scss';
// component
import Header from '../components/public/Header';
// React Bootstrap
import { Container, Row, Col, Image, Tab, Nav } from 'react-bootstrap';
// React redux
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
function Mentse({ lang }) {

    const tabList = [
        {
            id: 1,
            to: null,
            title: 'སྨན་རྩིས།'
        },
        {
            id: 2,
            to: '/',
            title: 'འཆི་མེད་སྨན་རྩིས་ཁང་།'
        },
        {
            id: 3,
            to: null,
            title: 'རྣམ་ཐར།'
        },
        {
            id: 4,
            to: null,
            title: 'དཔྱད་རྩོམ།'
        },
        {
            id: 5,
            to: null,
            title: 'སྨན་བཅོས།'
        },
        {
            id: 6,
            to: null,
            title: 'སྨན་སྦྱོར།'
        },
        {
            id: 7,
            to: null,
            title: 'གསོ་རིག་ཐོན་དངོས།'
        },
    ]
    return (
        <>
            <Header />
            <Container className='kyagu'>
                <div className='kyaguBody pt-4 pr-5 pl-5'>
                    <Row className='kyaguContent d-flex align-items-center justify-content-center'>
                        <Col className='align-items-center'>
                        </Col>
                    </Row>
                    {
                        lang === 'CH' ? (
                            // chinese Section
                            <>
                                <Row>
                                    <Col>
                                        <div className='content'>
                                            <h3 className='text-left text-secondary'>青海省囊謙縣青美藏醫診所</h3>
                                            <p className='chineseParagraph'>
                                                青美藏醫診所是以傳統藏藥為基礎並結合西藏天象學的藏醫研究中心，1967年成立於藏區囊謙縣的東珼鄉熱拉村，為的是在這醫療貧乏的牧區讓牧民們能有基本的醫療照護。
                                                創辦診所的倉薩江巴青美醫師傳承了倉薩蔣揚洛珠仁波切的精湛醫術以及懸壺濟世的精神，希望能在醫療資源缺乏的藏區盡綿薄之力，倉薩江巴企美在許多西藏傳統知識領域都有深刻的研究及了解，特別是在藏醫學和西藏天象學方面。
                                                診所成立之初，多數牧民都住在偏遠沒有交通運輸到達的山間，崎嶇陡斜的山路和懸崖甚至牲畜難行，更別說用馬或犛牛代搬運物資。
                                                為了醫治病人，醫生必須自行攜帶著各種藥品翻山越嶺，能到診所看病的村民是極少數，大多時候都是醫生得背著藥箱出診。
                                                醫生購買醫療用品，收集草藥之後，在石碗中磨碎，手工製成一顆顆藥丸，所有病人的就診和藥品都是診所免費提供的。
                                                由於我們的醫生不放棄的鑽研分析當時的流行疾病，以他們的研究為根據，診所開始研製並開發新藥。
                                                1997年，診所移至囊謙縣，自此包括玉樹藏族自治州五個縣的農民，牧民們都因此而又有了更多看診機會。無論是在常見疾病還是必須使用傳統藏藥治療的慢性疾病上，我們的診療都受到了在地居民的肯定，除了使用傳統藏藥外，也採用傳統療法結合創新生醫技術，例如：科學藏藥萃取技術,超音波萃取,超臨界萃取,
                                                艾灸，放血，藥浴，指壓等。
                                                自1967年以來,我們根據所累積的病患個案不斷致力於研究，並努力為患者做檢查及治療。我們除了吸收新的醫學知識也竭盡全力傳承先人所創的傳統療法，診所最大的前景是希望能將傳統藏醫代代相傳。古老的智慧不但不失傳更能精益求精。
          </p>
                                        </div>
                                    </Col>
                                </Row>
                            </>
                        ) : (
                                // Tibetan Section
                                <>
                                    <Row className='kyaguContent d-flex align-items-center justify-content-center'>
                                        <Col className='align-items-center'>
                                            {/* Header Image */}
                                            {/* Title */}
                                            <h3 className='text-left text-secondary tibetan_Dutsa mb-3'>
                                                སྨན་རྩིས།
                    </h3>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Tab.Container id='left-tabs' defaultActiveKey='0'>
                                                <Row>
                                                    <Col sm={5} md={3}>
                                                        <Nav variant='pills' className='flex-column '>
                                                            {/* Tabs */}
                                                            {
                                                                tabList.map((tabItem, index) => {
                                                                    return (
                                                                        <Nav.Item className='navItem' key='id'>
                                                                            <Nav.Link eventKey={index}>
                                                                                <h4>{tabItem.title}</h4>
                                                                            </Nav.Link>
                                                                        </Nav.Item>)
                                                                })
                                                            }

                                                        </Nav>
                                                    </Col>

                                                    {/* Content */}
                                                    <Col sm={7} md={9}>
                                                        <Tab.Content className='tabContent'>
                                                            <Tab.Pane eventKey='1' className='tabPane'>

                                                                <p>
                                                                    <h1>བོད་ཡིག་</h1>
                                                                </p>
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey='second' className='tabPane'>
                                                                <p>i am Singapore</p>
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey='third' className='tabPane'>
                                                                <p>i am tibet</p>
                                                            </Tab.Pane>
                                                            <Tab.Pane eventKey='forth' className='tabPane'>
                                                                <p>i am tibet</p>
                                                            </Tab.Pane>
                                                        </Tab.Content>
                                                    </Col>
                                                </Row>
                                            </Tab.Container>
                                        </Col>
                                    </Row>
                                </>
                            )
                    }

                </div>
            </Container>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        lang: state.lang.lang,
    };
};

export default connect(mapStateToProps)(Mentse);
